import React from "react";
import Link from "./Link";

export const Button = (props) => {
  const {title, url, external, icon} = props;
  const classes = props?.classes || '';
  const iconSvg = icon ? (
    <svg className="ms-2" width={24} height={24}>
      <use xlinkHref={`#icon-${icon}`} />
    </svg>
  ) : '';

  if (!external) {
    return (
      <Link className={`btn btn-outline-white ${classes}`} to={url}>{title}{iconSvg}</Link>
    )
  } else {
    return (
      <a className={`btn btn-outline-white ${classes}`} target="_blank" rel="noopener noreferrer" href={url}>{title}{iconSvg}</a>
    )
  }

}
